import React from 'react';
import FormField from './FormField';
import { formatDocument, formatPhone } from '../utils/formatting';
import { FormErrors } from '../types/payment';

interface CustomerDataFormProps {
  formData: any;
  errors: FormErrors;
  onInputChange: (field: string, value: string) => void;
  showEmailField: boolean;
  showPhoneField: boolean;
}

const CustomerDataForm: React.FC<CustomerDataFormProps> = ({
  formData,
  errors,
  onInputChange,
  showEmailField,
  showPhoneField
}) => {
  const handleDocumentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDocument(e.target.value);
    onInputChange('customer-document', formatted);
  };

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value);
    onInputChange('customer-phone', formatted);
  };

  return (
    <div className="customer-data-grid">
      <FormField
        label="Nome Completo"
        required
        error={errors['customer-name']}
      >
        <input
          type="text"
          id="customer-name"
          value={formData['customer-name'] || ''}
          onChange={(e) => onInputChange('customer-name', e.target.value)}
          placeholder="Seu nome completo"
          className={errors['customer-name'] ? 'invalid' : ''}
        />
      </FormField>

      {showEmailField && (
        <FormField
          label="E-mail"
          required
          error={errors['customer-email']}
          className="field-optional visible"
        >
          <input
            type="email"
            id="customer-email"
            value={formData['customer-email'] || ''}
            onChange={(e) => onInputChange('customer-email', e.target.value)}
            placeholder="seu@email.com"
            className={errors['customer-email'] ? 'invalid' : ''}
          />
        </FormField>
      )}

      <FormField
        label="CPF/CNPJ"
        required
        error={errors['customer-document']}
      >
        <input
          type="text"
          id="customer-document"
          value={formData['customer-document'] || ''}
          onChange={handleDocumentChange}
          placeholder="000.000.000-00"
          className={errors['customer-document'] ? 'invalid' : ''}
        />
      </FormField>

      {showPhoneField && (
        <FormField
          label="Telefone"
          required
          error={errors['customer-phone']}
          className="field-optional visible"
        >
          <input
            type="text"
            id="customer-phone"
            value={formData['customer-phone'] || ''}
            onChange={handlePhoneChange}
            placeholder="(00) 00000-0000"
            className={errors['customer-phone'] ? 'invalid' : ''}
          />
        </FormField>
      )}
    </div>
  );
};

export default CustomerDataForm;